import React from 'react'
import { useDispatch } from 'react-redux'
import StyleWrapper from 'publisher/components/core/StyleWrapper'
import CommonWebinarRegistrationDate from 'common/components/entities/WebinarRegistrationDate/WebinarRegistrationDate'
import WebinarRegistrationDateInterface from 'common/types/entities/WebinarRegistrationDateInterface'
import { changeField } from 'publisher/actions/optInActions'
import FieldErrors from '../../../components/FieldErrors'
import {
  usePage,
  pageSelectors,
  optInSelectors,
  useOptIn,
} from '../../../store'

type WebinarRegistrationDateProps = {
  entity: WebinarRegistrationDateInterface
}

function WebinarRegistrationDate({ entity }: WebinarRegistrationDateProps) {
  const dispatch = useDispatch()
  const locale = usePage(pageSelectors.getLocale)
  const errors = useOptIn(optIn =>
    optInSelectors.getFieldErrors(optIn, 'datetime'),
  )
  const time = useOptIn(optIn =>
    optInSelectors.getFieldValue(optIn, 'datetime'),
  )

  function handleChangeField(value: string | number) {
    dispatch(changeField('datetime', value))
  }

  return (
    <StyleWrapper
      appearance={entity.appearance}
      margin={entity.margin}
      mobileMargin={entity.mobileMargin}
    >
      <CommonWebinarRegistrationDate
        attrId={entity.htmlAttrId}
        interval={entity.interval}
        spaceBetween={entity.spaceBetween}
        scheduledHours={entity.scheduledHours}
        timeFormat={entity.timeFormat}
        changeTime={handleChangeField}
        locale={locale}
        time={time}
      />
      <FieldErrors errors={errors} />
    </StyleWrapper>
  )
}

export default WebinarRegistrationDate
